import { render, staticRenderFns } from "./phoneList.vue?vue&type=template&id=5441a7d6&scoped=true&"
import script from "./phoneList.vue?vue&type=script&lang=js&"
export * from "./phoneList.vue?vue&type=script&lang=js&"
import style0 from "./phoneList.vue?vue&type=style&index=0&id=5441a7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5441a7d6",
  null
  
)

export default component.exports